import { useEffect, useRef } from 'react';

/**
 * Dual favicon system for MFE
 * @param mfeFaviconUrl - MFE favicon URL (favicon2)
 */
export const useFavicon = (mfeFaviconUrl?: string) => {
  const originalFaviconRef = useRef<string | null>(null);

  useEffect(() => {
    if (!mfeFaviconUrl) return;

    let faviconLink = document.querySelector(
      'link[rel="icon"]'
    ) as HTMLLinkElement;

    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      faviconLink.type = 'image/x-icon';
      document.head.appendChild(faviconLink);
    }

    // Store original favicon on first run
    if (originalFaviconRef.current === null) {
      originalFaviconRef.current = faviconLink.href;
    }

    // Set MFE favicon
    faviconLink.href = mfeFaviconUrl;

    // Cleanup: restore original favicon when MFE unmounts
    return () => {
      if (originalFaviconRef.current) {
        const favicon = document.querySelector(
          'link[rel="icon"]'
        ) as HTMLLinkElement;
        if (favicon) {
          favicon.href = originalFaviconRef.current;
        }
      }
    };
  }, [mfeFaviconUrl]);
};
